module.exports = __webpack_public_path__ + "shattered.png?ea2316224d45899c59bc285ba09dd920";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/patterns/shattered.png
// module id = 612
// module chunks = 0